export const CONTACT_CATEGORIES = [
  { value: '', label: '選択してください' },
  { value: 'general', label: '一般的なお問い合わせ' },
  { value: 'product', label: '製品について' },
  { value: 'pricing', label: '料金・プランについて' },
  { value: 'technical', label: '技術的なご相談' },
  { value: 'partnership', label: 'パートナーシップ・提携' },
  { value: 'other', label: 'その他' },
];
